import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={28 * (props.hx ?? 1)}
    viewBox="0 0 17 28"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.522 1.81c1.289 0 4.638-1.935 6.573.177 1.551 1.692.979 5.76-.133 8.5-.414 1.018-.272 2.152-.249 3.251.125 6.055-.872 9.222-1.96 11.29-1.315 2.498-2.156 2.095-2.15-.885.005-2.277-.517-7.517-2.067-7.642-1.401 0-1.846 6.133-1.879 9.093-.02 1.78-.9 2.43-1.982.219-1.359-2.776-2.429-8.736-2.105-12.115a6.8 6.8 0 0 0-.488-3.21C.97 7.747.398 3.678 1.95 1.987 3.884-.125 7.233 1.81 8.522 1.81z"
    />
  </svg>
);
export default SvgNormal;
